<template>
  <div>
    <div class="budget">
      <p class="level-2" :class="{ mt: !hideRadio }">{{ budgetTitle }}</p>
      <p
        v-show="form.mode == '放量投放' && budgetTitle == '日预算'"
        class="tip-bid"
      >
        <i class="el-icon-info"></i
        >请设置贴近实际投放的预算，放量投放下无需出价，系统会尽量花光预算
      </p>
      <el-radio-group
        v-if="!hideRadio"
        v-model="form.budget"
        size="medium"
        @change="handleChange"
      >
        <el-radio-button :label="300">￥300</el-radio-button>
        <el-radio-button :label="500">￥500</el-radio-button>
        <el-radio-button :label="1000">￥1000</el-radio-button>
        <el-radio-button :label="5000">￥5000</el-radio-button>
        <el-radio-button :label="10000">￥10000</el-radio-button>
        <el-radio-button :label="null">自定义</el-radio-button>
      </el-radio-group>

      <template v-if="customBudget || hideRadio">
        <el-form-item prop="budget" style="margin-top: 20px">
          <el-input
            v-model="form.budget"
            class="c-input"
            placeholder="请输入金额"
          >
            <span
              slot="suffix"
              style="margin-right: 10px; color: rgb(153, 153, 153)"
              >元</span
            >
          </el-input>
        </el-form-item>
      </template>
    </div>

    <div class="bid" v-show="form.mode == '控成本投放'">
      <p class="level-2">
        出价
        <el-popover placement="top" trigger="hover" width="303">
          <p style="font-size: 12px; line-height: 1.8">
            出价指你愿意为每次转化支付目标价格。价格的高低会影响获得的转化次数。如，如果设置的目标价格过低，你可能会错失一部分转化。出价仅作为智能优化投放的成本参考，实际仍按展示付费
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>

      <el-form-item prop="bid" style="display: inline-block">
        <el-input v-model="form.bid" class="c-input" placeholder="请输入价格">
          <span
            slot="suffix"
            style="margin-right: 10px; color: rgb(153, 153, 153)"
            >元/{{ adviseText }}</span
          >
        </el-input>
      </el-form-item>
      <span class="advise"
        >根据相似店铺投放情况，建议出价
        <b class="advise-price">{{ advisePrice }}</b>
        元/<span>{{ adviseText }}</span>
      </span>
      <div class="tips">
        <el-image
          class="img"
          :src="require(`@/assets/images/simulation/icon_bao.png`)"
          fit="fit"
        ></el-image>
        <span>按展示付费(oCPM)，根据</span>
        <a
          class="link"
          href="https://school.jinritemai.com/doudian/web/article/aHMNDfneBP7r"
          target="_blank"
          rel="noopener noreferrer"
          >成本保障规则</a
        >
        <span>提供保障福利，请谨慎修改出价或定向，以免失去保障资格</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    budgetTitle: String,
    hideRadio: Boolean,
  },
  data() {
    return {
      customBudget: false,
    };
  },
  computed: {
    advisePrice() {
      if (this.form.action == "商品购买") return "22.79～42.73";
      else if (this.form.action == "粉丝提升") return "1.27～2.39";
      else if (this.form.action == "点赞评论") return "0.20～0.37";
      else if (this.form.action == "进入直播间") return "0.15～0.29";
      else if (this.form.action == "直播间商品点击") return "0.76～3.79";
      else if (this.form.action == "直播间下单") return "59.77～398.49";
      else if (this.form.action == "直播间成交") return "52.79～316.77";
      else if (this.form.action == "直播间粉丝提升") return "2.19～10.94";
      else if (this.form.action == "直播间评论") return "2.40～12.00";
    },
    adviseText() {
      if (this.form.action == "商品购买") return "下单";
      else if (this.form.action == "粉丝提升") return "关注";
      else if (this.form.action == "点赞评论") return "点击";
      else if (this.form.action == "进入直播间") return "观看";
      else if (this.form.action == "直播间商品点击") return "点击";
      else if (this.form.action == "直播间下单") return "下单";
      else if (this.form.action == "直播间成交") return "成交";
      else if (this.form.action == "直播间粉丝提升") return "关注";
      else if (this.form.action == "直播间评论") return "评论";
    },
  },
  methods: {
    handleChange(e) {
      this.customBudget = !!!e;
    },
  },
};
</script>

<style lang="less" scoped>
.level-2 {
  margin-top: 28px;
  margin-bottom: 12px;
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  &.mt {
    margin-top: 13px;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
}
.budget {
  .tip-bid {
    margin-top: -2px;
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 12px;
    color: #333;
    .el-icon-info {
      margin-right: 5px;
      font-size: 16px;
      color: #969696;
      vertical-align: middle;
    }
  }
}
.bid {
  .advise {
    margin-left: 20px;
    line-height: 32px;
    .advise-price {
      line-height: 19px;
      font-family: OPPOSans-H;
      font-size: 16px;
      color: #1f1f1f;
    }
  }
  .tips {
    margin-top: 8px;
    line-height: 18px;
    font-size: 12px;
    color: #666;
    .img {
      margin-right: 5px;
      vertical-align: top;
    }
    .link {
      margin: 0 4px;
      color: #194ce5;
    }
  }
}
::v-deep .c-input {
  width: 198px;
  .el-input__inner {
    background-color: #f2f2f2;
  }
}
</style>
<style lang="less">
.el-tooltip__popper {
  max-width: 420px;
  line-height: 1.5;
  .s {
    width: 200px;
    text-align: justify;
  }
}
</style>